// packages/app/src/components/admin/models/ParamHelp.tsx
// AGC: A small "(?)" button that toggles a popover explaining a model parameter or
// AGC: calculation. Used across the Argentina model config so every value is auditable.
import React, { useState } from 'react'
import { HelpCircle } from 'lucide-react'
import { FormulaPreview } from './FormulaPreview'

interface ParamHelpProps {
  text: string        // AGC: plain-language explanation (already translated)
  formula?: string    // AGC: optional formula shown in a code block
  source?: string     // AGC: optional citation
}

// AGC: Inline help toggle — no portal; renders an absolutely-positioned popover.
export const ParamHelp: React.FC<ParamHelpProps> = ({ text, formula, source }) => {
  const [open, setOpen] = useState(false)
  return (
    <span className="relative inline-block align-middle">
      <button
        type="button"
        aria-label="help"
        onClick={() => setOpen((v) => !v)}
        className="ml-1 text-slate-400 hover:text-slate-600"
      >
        <HelpCircle className="w-4 h-4" />
      </button>
      {open && (
        <div className="absolute z-50 mt-1 w-72 p-3 rounded-lg bg-white dark:bg-slate-800 shadow-lg border border-slate-200 dark:border-slate-700 text-sm text-slate-700 dark:text-slate-200">
          <p>{text}</p>
          {formula && <FormulaPreview title="" formula={formula} />}
          {source && <p className="mt-2 text-xs text-slate-500">{source}</p>}
        </div>
      )}
    </span>
  )
}
